import { request, requestNoBody, requestForm, download, upload } from "@/request/index";

// 1-登录
export function userLogin(data) {
    return requestNoBody({
        method: 'POST',
        url: '/admin/api/user/login',
        data: data
    })
}

// 2-获取用户信息
export function getUserPersonal() {
    return requestNoBody({
        method: 'GET',
        url: '/admin/api/user/personal',
    })
}

// 3-退出登录
export function userLogout() {
    return request({
        method: 'POST',
        url: '/admin/api/user/logout',
    })
}

// 4-修改手机号
export function updateMyPhone(data) {
    return request({
        method: 'POST',
        url: '/admin/api/user/updatePhone',
        data: data
    })
}

// 5-修改密码
export function updateMyPwd(data) {
    return request({
        method: 'POST',
        url: '/admin/api/user/updatePwd',
        data: data
    })
}

// 6-上传图片
export function uploadImg({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/image/uploadImageFile',
        data,
        files
    })
}
// 导出
export function exportCheckExce(data) {
    return download({
        method: 'POST',
        url: '/admin/api/good/excelStockDetailModel',
        data,
    })
}
export function exportExcel(data) {
    return download({
        method: 'POST',
        url: '/admin/api/record/exportExcel',
        data,
    })
}
export function orderExportModel(data) {
    return download({
        method: 'POST',
        url: '/admin/api/orderDetail/exportModel',
        data,
    })
}
export function orderExportTemplate(data) {
    return download({
        method: 'POST',
        url: '/admin/api/orderDetail/exportTemplate',
        data,
    })
}
export function orderImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/orderDetail/importData',
        data,
        files
    })
}
export function importOutWorkOrderData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/orderDetail/importOutWorkOrderData',
        data,
        files
    })
}
export function importInWorkOrderData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/orderDetail/importInWorkOrderData',
        data,
        files
    })
}
// 导入设备
export function deviceImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/device/importData',
        data,
        files
    })
}

// 导出设备
export function deviceExcelModel(data) {
    return download({
        method: 'POST',
        url: '/admin/api/device/excelModel',
        data,
    })
}
// 导入柜格
export function lockerImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/locker/importData',
        data,
        files
    })
}
// 导入衣物
export function clothingImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/good/importData',
        data,
        files
    })
}
// 导出衣物
export function clothingExcelModel(data) {
    return download({
        method: 'POST',
        url: '/admin/api/good/excelModel',
        data,
    })
}
// 导入用户
export function userImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/dev/user/importData',
        data,
        files
    })
}
// 导入部门
export function departmentImportData({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/department/importData',
        data,
        files
    })
}
/**
 * 云柜管理
 */
//  -------------云柜列表-------------
// 7-获取云柜列表（下拉选择框）
export function arrangeDeviceList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/arrangeDeviceList',
        data
    })
}
// 8-获取云柜列表
export function deviceList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/listByPage',
        data
    })
}
// 9-新增云柜
export function addDeviceList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/add',
        data
    })
}
// 10-编辑云柜
export function updateDeviceList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/update',
        data
    })
}
// 11-删除云柜
export function deleteDeviceList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/delete',
        data
    })
}
// 12-开启广告
export function setAdSwitch(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/setAdSwitch',
        data
    })
}
// 13-盘点
export function goodInventory(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/goodInventory',
        data,
    })
}
export function queryInventoryStatus(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/queryInventoryStatus',
        data,
    })
}
// 14-重启
export function deviceReboot(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/reboot',
        data,
    })
}
// 15-日志上传
export function deviceLogcat(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/logcat',
        data,
    })
}
// 16-设备升级
export function appUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/appUpdate',
        data,
    })
}
// 17-初始化
export function deviceInit(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/init',
        data,
    })
}
// 18-定时盘点
export function deviceSetTask(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/setTask',
        data,
    })
}
// 19-取消定时盘点
export function deviceCancelTask(data) {
    return request({
        url: '/admin/api/device/cancelTask',
        method: 'POST',
        data,
    })
}
// 20-设置工单领取绑定
export function setWorkOrderTakeUser(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/setWorkOrderTakeUser',
        data,
    })
}
// 根据id查询设备信息
export function getDeviceById(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/getById',
        data,
    })
}
// 查询工单用户回显
export function orderTakeUserList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/orderTakeUser/listByPage',
        data,
    })
}
// 物品查询柜格
export function queryBoxByGoodId(data) {
    return request({
        method: 'POST',
        url: '/admin/api/locker/queryBoxByGoodId',
        data,
    })
}
// 20-设置关门时间
export function setCloseTime(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/setCloseTime',
        data,
    })
}

// 21-设置读取时间
export function setReadTime(data) {
    return request({
        method: 'POST',
        url: '/admin/api/device/setReadTime',
        data,
    })
}
// 设备类型列表
export function deviceTypeListByPage(data) {
    return request({
        method: 'POST',
        url: '/admin/api/deviceType/listByPage',
        data,
    })
}
// 新增设备类型
export function addDeviceType(data) {
    return request({
        method: 'POST',
        url: '/admin/api/deviceType/add',
        data,
    })
}
// 编辑设备类型
export function updateDeviceType(data) {
    return request({
        method: 'POST',
        url: '/admin/api/deviceType/update',
        data,
    })
}
// 删除设备类型
export function deleteDeviceType(data) {
    return request({
        method: 'POST',
        url: '/admin/api/deviceType/delete',
        data,
    })
}
// app类型列表
export function appTypeListByPage(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appType/listByPage',
        data,
    })
}
// 新增app类型
export function appTypeListAdd(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appType/add',
        data,
    })
}
// 编辑app类型
export function appTypeListUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appType/update',
        data,
    })
}
// 删除app类型
export function appTypeListDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appType/delete',
        data,
    })
}
// 升级包列表
export function appUpdateListByPage(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appUpdate/listByPage',
        data,
    })
}
// 上传apk文件
export function appUploadApkFile({ data, files }) {
    return upload({
        method: 'POST',
        url: '/admin/api/appUpdate/uploadApkFile',
        data, files
    })
}
// 新增升级包
export function appUpdateAdd(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appUpdate/add',
        data,
    })
}
// 编辑升级包
export function appUpdateUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appUpdate/update',
        data,
    })
}
// 删除升级包
export function appUpdateDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appUpdate/delete',
        data,
    })
}
// 启用禁用升级包
export function appStatusUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/appUpdate/setAppStatus',
        data,
    })
}

//  -------------柜格列表-------------
// 22-获取柜格列表
export function lockerList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/locker/listByPage',
        data
    })
}
// 23-新增柜格
export function addLockerList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/locker/addLocker',
        data
    })
}
// 24-编辑柜格
export function updateLockerList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/locker/update',
        data
    })
}
// 25-删除柜格
export function deleteLockerList(data) {
    return request({
        url: '/admin/api/locker/batchDeleteLocker',
        method: 'POST',
        data,
    })
}
// 26-获取柜格类型
export function getLockerType(data) {
    return request({
        url: '/admin/api/locker/getLockerType',
        method: 'POST',
        data,
    })
}
// 释放柜格
export function releaseLocker(data) {
    return request({
        url: '/admin/api/locker/releaseLock',
        method: 'POST',
        data,
    })
}
// 设置预警值列表
export function setAlarmValue(data) {
    return request({
        url: '/admin/api/locker/setAlarmValue',
        method: 'POST',
        data,
    })
}
// 27-获取货架列表
export function storageRackList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRack/listByPage',
        data
    })
}
// 28-新增货架
export function addStorageRackList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRack/add',
        data
    })
}
// 29-编辑货架
export function updateStorageRackList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRack/update',
        data
    })
}
// 30-删除货架
export function deleteStorageRackList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRack/deleteBatch ',
        data
    })
}
// 31-货架详情
export function rackItemDetailList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRackItem/rackItemDetail',
        data
    })
}
// 32-新增排列
export function addRackItemList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRackItem/addRackItem',
        data
    })
}
// 33-编辑排列
export function updateRackItemList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRackItem/update',
        data
    })
}
// 34-删除排列
export function deleteRackItemList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/storageRackItem/deleteBatch',
        data
    })
}
// 35-上架(货架)
export function storageRackPutaway(data) {
    return request({
        url: '/admin/api/storageRackItem/putaway',
        method: 'POST',
        data,
    })
}
// export function lockerPutaway(data) {
//     return request({
//         url: '/admin/api/locker/putaway',
//         method: 'POST',
//         data,
//     })
// }
export function lockerInStock(data) {
    return request({
        url: '/admin/api/locker/inStock',
        method: 'POST',
        data,
    })
}
export function lockerOutStock(data) {
    return request({
        url: '/admin/api/locker/outStock',
        method: 'POST',
        data,
    })
}
// 36-获取物品列表（上架）
export function goodsList(data) {
    return request({
        url: '/admin/api/good/goodsList',
        method: 'POST',
        data,
    })
}
// 37-开锁
export function openLockerDoor(data) {
    return request({
        url: '/admin/api/locker/openDoor',
        method: 'POST',
        data,
    })
}
// 38-状态更新
export function batchUpdateLocker(data) {
    return request({
        url: '/admin/api/locker/batchUpdateLocker',
        method: 'POST',
        data,
    })
}
//  -------------异常记录-------------
// 39-获取异常记录列表
export function abnormalListByPage(data) {
    return request({
        url: '/admin/api/error/listByPage',
        method: 'POST',
        data,
    })
}
//  -------------开门记录-------------
// 40-获取开门记录列表
export function openDoorListByPage(data) {
    return request({
        url: '/admin/api/openDoorRecord/listByPage',
        method: 'POST',
        data,
    })
}
/**
 * 用户管理
 */
//  -------------用户列表-------------
// 41-获取用户列表
export function devUserList(data) {
    return request({
        url: '/admin/api/dev/user/listByPage',
        method: 'POST',
        data,
    })
}
// 42-添加用户
export function devUserAdd(data) {
    return request({
        url: '/admin/api/dev/user/add',
        method: 'POST',
        data,
    })
}
// 43-编辑用户
export function devUserUpdate(data) {
    return request({
        url: '/admin/api/dev/user/update',
        method: 'POST',
        data,
    })
}
// 44-删除用户
export function devUserDelete(data) {
    return request({
        url: '/admin/api/dev/user/delete',
        method: 'POST',
        data,
    })
}
// 查询用户绑定的衣物
export function userBindClothesList(data) {
    return request({
        url: '/admin/api/dev/user/userBindClothesList',
        method: 'POST',
        data,
    })
}
/**
 * 物品管理
 */
//  -------------物品分类-------------
// 45-获取物品分类列表
export function groupListByPage(data) {
    return request({
        url: '/admin/api/group/listByPage',
        method: 'POST',
        data,
    })
}
// 46-新增编辑分类
export function groupAdd(data) {
    return request({
        url: '/admin/api/group/add',
        method: 'POST',
        data,
    })
}
export function groupUpdate(data) {
    return request({
        url: '/admin/api/group/update',
        method: 'POST',
        data,
    })
}
// 47-删除分类
export function groupDelete(data) {
    return request({
        url: '/admin/api/group/delete',
        method: 'POST',
        data,
    })
}
//  -------------物品列表-------------
// 48-获取物品列表
export function goodsListByPage(data) {
    return request({
        url: '/admin/api/good/listByPage',
        method: 'POST',
        data,
    })
}
// 49-新增编辑物品
export function goodsAdd(data) {
    return request({
        url: '/admin/api/good/add',
        method: 'POST',
        data,
    })
}
export function goodsUpdate(data) {
    return request({
        url: '/admin/api/good/update',
        method: 'POST',
        data,
    })
}
// 50-删除物品
export function goodsDelete(data) {
    return request({
        url: '/admin/api/good/delete',
        method: 'POST',
        data,
    })
}
//  -------------物品库存-------------
// 51-获取货柜库存列表
export function lockerStock(data) {
    return request({
        url: '/admin/api/locker/lockerStock',
        method: 'POST',
        data,
    })
}
// 52-获取货架库存列表
export function rackItemStock(data) {
    return request({
        url: '/admin/api/storageRackItem/rackItemStock',
        method: 'POST',
        data,
    })
}
// 导出记录
export function exportExcelRecord(data) {
    return download({
        method: 'POST',
        url: '/admin/api/record/exportExcel',
        data,
    })
}
/**
 * 记录管理
 */
//  -------------记录列表-------------
// 53-获取（全部、入库、出库）记录列表
export function recordListByPage(data) {
    return request({
        url: '/admin/api/record/listByPageNew',
        method: 'POST',
        data,
    })
}
// 记录统计
export function recordStatistical(data) {
    return request({
        url: '/admin/api/record/recordStatistical',
        method: 'POST',
        data,
    })
}
// 54-获取错误记录列表
export function errorRecordListByPage(data) {
    return request({
        url: '/admin/api/errorRecord/listByPage',
        method: 'POST',
        data,
    })
}
//  -------------申请记录列表-------------
// 55-获取申请记录列表
export function applyRecordListByPage(data) {
    return request({
        url: '/admin/api/accredit/findApplicationList',
        method: 'POST',
        data,
    })
}
// 56-获取申请记录详情
export function applyRecordDetail(data) {
    return request({
        url: '/admin/api/accredit/getDetail',
        method: 'POST',
        data,
    })
}
// 57-获取申请用户列表
export function applyUserList(data) {
    return request({
        url: '/admin/api/dev/user/userList',
        method: 'POST',
        data,
    })
}
// 58-根据设备id查找工具列表
export function findGoodByDeviceId(data) {
    return request({
        url: '/admin/api/accredit/findGoodByDeviceId',
        method: 'POST',
        data,
    })
}
// 59-用户申请、新增工具 
export function applicationTool(data) {
    return request({
        url: '/admin/api/accredit/applicationTool',
        method: 'POST',
        data,
    })
}
// 60-删除申请列表
export function deleteApplication(data) {
    return request({
        url: '/admin/api/accredit/deleteApplication',
        method: 'POST',
        data,
    })
}
// 61-审批申请
export function accreditApprove(data) {
    return request({
        url: '/admin/api/accredit/approve',
        method: 'POST',
        data,
    })
}
// 62-删除申请详情列表
export function deleteApplyDetail(data) {
    return request({
        url: '/admin/api/accredit/deleteGood',
        method: 'POST',
        data,
    })
}
// 63-编辑数量
export function accreditUpdate(data) {
    return request({
        url: '/admin/api/accredit/update',
        method: 'POST',
        data,
    })
}
/**
 * 工单管理
 */
//  -------------工单列表-------------
// 获取工单列表
export function workOrderByPage(data) {
    return request({
        url: '/admin/api/workOrder/listByPage',
        method: 'POST',
        data,
    })
}
// 新增工单
export function addWorkOrder(data) {
    return request({
        url: '/admin/api/workOrder/addOutWorkOrder',
        // url: '/admin/api/workOrder/add',
        method: 'POST',
        data,
    })
}
export function addWorkOrder2(data) {
    return request({
        url: '/admin/api/workOrder/addInWorkOrder',
        // url: '/admin/api/workOrder/add',
        method: 'POST',
        data,
    })
}
// 编辑工单
export function updateWorkOrder(data) {
    return request({
        url: '/admin/api/workOrder/updateOutWorkOrder',
        // url: '/admin/api/workOrder/update',
        method: 'POST',
        data,
    })
}
export function updateWorkOrder2(data) {
    return request({
        url: '/admin/api/workOrder/updateInWorkOrder',
        // url: '/admin/api/workOrder/update',
        method: 'POST',
        data,
    })
}
// 删除工单
export function deleteWorkOrder(data) {
    return request({
        // url: '/admin/api/workOrder/delete',
        url: '/admin/api/workOrder/deleteOutWorkOrder',
        method: 'POST',
        data,
    })
}
export function deleteWorkOrder2(data) {
    return request({
        url: '/admin/api/workOrder/deleteInWorkOrder',
        // url: '/admin/api/workOrder/delete',
        method: 'POST',
        data,
    })
}
//  -------------工单物料列表-------------
// 获取工单详情(工单物料)
export function workOrderDetailByPage(data) {
    return request({
        url: '/admin/api/orderDetail/listByPage',
        method: 'POST',
        data,
    })
}
// 新增工单物料
export function addOrderDetail(data) {
    return request({
        // url: '/admin/api/orderDetail/add',
        url: ' /admin/api/orderDetail/addOutWorkOrderGood',
        method: 'POST',
        data,
    })
}
export function addOrderDetail2(data) {
    return request({
        // url: '/admin/api/orderDetail/add',
        url: ' /admin/api/orderDetail/addInWorkOrderGood',
        method: 'POST',
        data,
    })
}
// 编辑工单物料
export function updateOrderDetail(data) {
    return request({
        // url: '/admin/api/orderDetail/update',
        url: '/admin/api/orderDetail/updateOutWorkOrderGood',
        method: 'POST',
        data,
    })
}
export function updateOrderDetail2(data) {
    return request({
        // url: '/admin/api/orderDetail/update',
        url: '/admin/api/orderDetail/updateInWorkOrderGood',
        method: 'POST',
        data,
    })
}
// 删除工单物料
export function deleteOrderDetail(data) {
    return request({
        // url: '/admin/api/orderDetail/delete',
        url: '/admin/api/orderDetail/deleteOutWorkOrderGood',
        method: 'POST',
        data,
    })
}
export function deleteOrderDetail2(data) {
    return request({
        // url: '/admin/api/orderDetail/delete',
        url: '/admin/api/orderDetail/deleteInWorkOrderGood',
        method: 'POST',
        data,
    })
}
// 查询设备物料
export function queryGoodByBox(data) {
    return request({
        url: '/admin/api/locker/queryGoodByBox',
        method: 'POST',
        data,
    })
}
/**
 * 盘点管理
 */
//  -------------盘点记录-------------
// 64-获取盘点记录列表
export function inventoryListByPage(data) {
    return request({
        url: '/admin/api/goodCheck/checkOrderListByPage',
        method: 'POST',
        data,
    })
}
// 65-获取盘点记录详情
export function inventoryDetailByPage(data) {
    return request({
        url: '/admin/api/goodCheck/getDetailByPage',
        method: 'POST',
        data,
    })
}
//  -------------盘点时间-------------
// 66-获取盘点时间列表
export function inventoryTimeListByPage(data) {
    return request({
        url: '/admin/api/readScheduling/listByPage',
        method: 'POST',
        data,
    })
}
// 67-添加盘点时间
export function inventoryTimeAdd(data) {
    return request({
        url: '/admin/api/readScheduling/addAll',
        method: 'POST',
        data,
    })
}
// 68-编辑盘点时间
export function inventoryTimeUpdate(data) {
    return request({
        url: '/admin/api/readScheduling/update',
        method: 'POST',
        data,
    })
}
// 69-删除盘点时间
export function inventoryTimeDelete(data) {
    return request({
        url: '/admin/api/readScheduling/delete',
        method: 'POST',
        data,
    })
}
/**
 * 广告管理
 */
//  -------------广告分类-------------
// 70-获取广告分类列表
export function advertSortListByPage(data) {
    return request({
        url: '/admin/api/advertisingGroup/listByPage',
        method: 'POST',
        data,
    })
}
// 71-新增广告分类
export function addAdvertSotr(data) {
    return request({
        url: '/admin/api/advertisingGroup/add',
        method: 'POST',
        data,
    })
}
// 72-编辑广告分类
export function updateAdvertSotr(data) {
    return request({
        url: '/admin/api/advertisingGroup/update',
        method: 'POST',
        data,
    })
}
// 73-删除广告分类
export function deleteAdvertSotr(data) {
    return request({
        url: '/admin/api/advertisingGroup/delete',
        method: 'POST',
        data,
    })
}
//  -------------广告列表-------------
// 74-获取广告列表
export function advertListByPage(data) {
    return request({
        url: '/admin/api/advertisement/listByPage',
        method: 'POST',
        data,
    })
}
// 75-广告分类列表
export function queryGroupList(data) {
    return request({
        url: '/admin/api/advertisingGroup/queryGroupList',
        method: 'POST',
        data,
    })
}
// 76-新增广告
export function addDdvert(data) {
    return request({
        url: '/admin/api/advertisement/add',
        method: 'POST',
        data,
    })
}
// 77-编辑广告
export function updateDdvert(data) {
    return request({
        url: '/admin/api/advertisement/update',
        method: 'POST',
        data,
    })
}
// 78-删除广告
export function deleteDdvert(data) {
    return request({
        url: '/admin/api/advertisement/delete',
        method: 'POST',
        data,
    })
}
// 79-根据多设备发布广告
export function devicePlayByDevices(data) {
    return request({
        url: '/admin/api/devicePlay/bindAdByDevices',
        method: 'POST',
        data,
    })
}
//  -------------播放广告-------------
// 80-根据设备发布广告
export function pushAdByDevice(data) {
    return request({
        url: '/admin/api/devicePlay/pushAdByDevice',
        method: 'POST',
        data,
    })
}
// 81-根据设备删除广告
export function deleteAdByDevice(data) {
    return request({
        url: '/admin/api/devicePlay/deleteAdByDevice',
        method: 'POST',
        data,
    })
}
// 82-查看广告播放列表
export function playListByPage(data) {
    return request({
        url: '/admin/api/devicePlay/listByPage',
        method: 'POST',
        data,
    })
}
// 83-修改播放列表
export function updatePlayList(data) {
    return request({
        url: '/admin/api/devicePlay/update',
        method: 'POST',
        data,
    })
}
// 84-根据ID发布广告
export function pushAdById(data) {
    return request({
        url: '/admin/api/devicePlay/pushAdById',
        method: 'POST',
        data,
    })
}
// 85-根据ID删除广告
export function deleteAdById(data) {
    return request({
        url: '/admin/api/devicePlay/deleteAdById',
        method: 'POST',
        data,
    })
}

/**
 * 系统管理
 */
//  -------------用户管理-------------
// 获取用户列表
export function userSystemList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/user/listPage',
        data
    })
}
//添加编辑用户
export function saveSystemUser(data) {
    return request({
        method: 'POST',
        url: '/admin/api/user/save',
        data
    })
}
// 删除用户
export function deleteSystemUser(data) {
    return request({
        method: 'POST',
        url: '/admin/api/user/delete',
        data
    })
}
// 绑定设备
export function userBindDevice(data) {
    return request({
        url: '/admin/api/device/arrangeDevice',
        method: 'POST',
        data: data
    })
}
// 重置密码
export function userResetPass(params) {
    return request({
        url: '/admin/api/user/resetPwd',
        method: 'GET',
        params: params
    })
}
// export function userResetPass(data) {
//     return requestForm({
//         url: '/admin/api/user/resetPwd',
//         method: 'GET',
//         data,
//     })
// }
// export function userResetPass(data) {
//     return requestNoBody({
//         method: 'GET',
//         url: '/admin/api/user/resetPwd',
//         params: data
//     })
// }
//  -------------权限管理-------------
// 获取权限侧边栏数据
export function authorityTreeData(data) {
    return request({
        method: 'POST',
        url: '/admin/api/menu/getMenuTree',
        data
    })
}

// 获取权限列表
export function authorityList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/permissions/list',
        data: data
    })
}
// 新增编辑权限
export function authoritySave(data) {
    return request({
        method: 'POST',
        url: '/admin/api/permissions/save',
        data: data
    })
}
// 删除权限
export function authorityDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/permissions/delete',
        data: data
    })
}
//  -------------菜单管理-------------
// 新增编辑菜单
export function menuSave(data) {
    return request({
        method: 'POST',
        url: '/admin/api/menu/save',
        data: data
    })
}
// 删除菜单
export function menuDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/menu/delete',
        data: data
    })
}
//  -------------角色管理-------------
// 获取角色列表
export function roleList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/role/listPage',
        data: data
    })
}
export function roleListAll(data) {
    return request({
        method: 'POST',
        url: '/admin/api/role/list',
        data: data
    })
}
// 新增编辑角色
export function roleSave(data) {
    return request({
        method: 'POST',
        url: '/admin/api/role/save',
        data: data
    })
}
// 删除角色
export function roleDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/role/delete',
        data: data
    })
}
// -------------企业管理-------------
// 获取单位列表
export function enterpriseList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/enterprise/listAll',
        data: data
    })
}
// 新增编辑单位
export function enterpriseSave(data) {
    return request({
        method: 'POST',
        url: '/admin/api/enterprise/save',
        data: data
    })
}
// 删除单位
export function enterpriseDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/enterprise/delete',
        data: data
    })
}
// -------------部门管理-------------
// 获取部门列表
export function departmentList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/department/listByPage',
        data: data
    })
}
// 筛选部门列表
export function departmentQueryList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/department/queryList',
        data: data
    })
}
// 编辑部门
export function departmentUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/department/update',
        data: data
    })
}
// 新增部门
export function departmentAdd(data) {
    return request({
        method: 'POST',
        url: '/admin/api/department/add',
        data: data
    })
}
// 删除部门
export function departmentDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/department/delete',
        data: data
    })
}
// -------------操作日志-------------
export function logList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/operationLog/listByPage',
        data: data
    })
}
// -------------参数配置-------------
export function parameterConfigList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/config/listByPage',
        data: data
    })
}
// 新增参数配置
export function parameterConfigAdd(data) {
    return request({
        method: 'POST',
        url: '/admin/api/config/add',
        data: data
    })
}
// 编辑参数配置
export function parameterConfigUpdate(data) {
    return request({
        method: 'POST',
        url: '/admin/api/config/update',
        data: data
    })
}
// 删除参数配置
export function parameterConfigDelete(data) {
    return request({
        method: 'POST',
        url: '/admin/api/config/delete',
        data: data
    })
}
/**
 * 首页
 */
// 查询设备 
export function queryDeviceHome() {
    return requestNoBody({
        url: '/admin/api/home/queryDevice',
        method: 'GET',
    })
}
// 领取回收统计
export function queryRecordCountHome() {
    return requestNoBody({
        url: '/admin/api/home/queryRecordCount',
        method: 'GET',
    })
}

// 使用和告警记录
export function queryRecordListHome() {
    return requestNoBody({
        url: '/admin/api/home/queryRecord',
        method: 'GET',
    })
}

// 衣物绑定用户
export function goodBindUser(data) {
    return request({
        method: 'POST',
        url: '/admin/api/good/goodBindUser',
        data: data
    })
}
// 查询用户列表（部门 用户）
export function queryDepartUserList(data) {
    return request({
        method: 'POST',
        url: '/admin/api/dev/user/queryUserDept',///admin/api/good/goodAddUser
        data: data
    })
}